import React from "react";
import { BONOS } from "../../data/content";
export function Bonos() {
  return <section className="bg-neutral-950 py-16 px-4 border-t border-neutral-900" data-id="element-35" data-mp="13k9mx3es1hu6">
      <div className="max-w-6xl mx-auto" data-id="element-36" data-mp="13mc9tekmuuuo">
        <div className="text-center mb-10" data-id="element-37" data-mp="1hipu0vgjxacu">
          <h2 className="font-display text-3xl sm:text-5xl text-white uppercase leading-none" data-id="element-38" data-mp="1hhofui48o7qw">
            🎁 6 Bonos Estratégicos
          </h2>
          <p className="font-condensed text-xl text-[#e10600] tracking-widest mt-2" data-id="element-39" data-mp="oubwshxaei2c">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-40" data-mp="jxtqveq80dof">
          {BONOS.map(b => <article key={b.num} className="relative bg-black border border-neutral-800 rounded-2xl p-6 overflow-hidden" data-id="element-41" data-mp="ym7xm0qrcma9">
              <span className="absolute top-4 right-4 font-display text-5xl text-neutral-800 select-none" data-id="element-42" data-mp="63kf8t35blcv">
                {b.num}
              </span>
              <div className="text-2xl mb-2" data-id="element-43" data-mp="13oinews2w7c">🎁</div>
              <div className="font-display text-[#e10600] text-sm tracking-wide mb-1" data-id="element-44" data-mp="2z9mecjofbisu">
                BONO {b.num.replace(/^0/, "")}
              </div>
              <h4 className="font-condensed text-2xl text-white tracking-wide leading-tight" data-id="element-45" data-mp="39077vsp8px4w">
                {b.title}
              </h4>
              <p className="text-neutral-400 text-sm mt-2 leading-relaxed" data-id="element-46" data-mp="3d0r7d2xadcu7">{b.desc}</p>
              <div className="mt-4 flex items-center gap-2" data-id="element-47" data-mp="2gcbht6u6f3h3">
                <span className="text-neutral-500 line-through text-sm" data-id="element-48" data-mp="2gdwbku8o2idw">{b.price}</span>
                <span className="font-display text-[#e10600] text-lg" data-id="element-49" data-mp="2lcqtzv2q24xh">→ GRATIS</span>
              </div>
            </article>)}
        </div>

        <div className="mt-10 text-center" data-id="element-50" data-mp="2ubktbt7ft9eq">
          <div className="inline-block bg-[#e10600] rounded-xl px-6 py-4" data-id="element-51" data-mp="2u986b1mto8ut">
            <p className="font-condensed text-xl sm:text-2xl text-white tracking-wide" data-id="element-52" data-mp="4lh965wiorrp">
              Valor total de bonos:{" "}
              <span className="line-through opacity-70" data-id="element-53" data-mp="9mwttwus8w9k">$51.000 ARS</span> → GRATIS con tu Megapack
            </p>
          </div>
        </div>
      </div>
    </section>;
}